module.exports = __webpack_public_path__ + "static/media/about-banner.d58a77e2.jpg";